/**
 * InfoRow Component
 *
 * Label/value row for detail pages. Designed to sit inside a `MetadataCard`.
 */

import React from 'react';

export interface InfoRowProps {
  label: string;
  value: React.ReactNode;
  dir?: 'ltr' | 'rtl';
  emptyValue?: string;
  /** Stack the label above the value, for long text such as notes. */
  stacked?: boolean;
}

export const InfoRow: React.FC<InfoRowProps> = ({
  label,
  value,
  dir = 'ltr',
  emptyValue = 'N/A',
  stacked = false,
}) => {
  const resolved =
    value === null || value === undefined || value === '' ? emptyValue : value;

  if (stacked) {
    return (
      <div className="py-2 border-b border-gray-200/50 last:border-b-0">
        <span className="block text-gray-500 text-sm mb-1">{label}</span>
        <span
          className="block text-slate-700 font-medium whitespace-pre-wrap break-words"
          dir={dir}
        >
          {resolved}
        </span>
      </div>
    );
  }

  return (
    <div className="flex justify-between items-center gap-4 py-2 border-b border-gray-200/50 last:border-b-0">
      <span className="text-gray-500 text-sm shrink-0">{label}</span>
      <span
        className="text-slate-700 font-medium text-right break-words min-w-0"
        dir={dir}
      >
        {resolved}
      </span>
    </div>
  );
};

export default InfoRow;
